import '../index.css';
import { Outlet, useLocation  } from "react-router-dom";
import { useState, useEffect } from 'react';
import { fetchWithAuth } from "../auth"

const Head = () => {
  const location = useLocation();
  const [userState, setUserState] = useState();

  function logout() {
    fetchWithAuth('/logout', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(data => {
        window.location.href = "/login";
      })
  }

  async function f_getuser() {
    if (location.pathname === '/login') {
      return;
    }
    fetchWithAuth('/user', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        })
          .then(data => {
            setUserState(data.user)
          })
  }

  useEffect(() => {
    f_getuser();
  });

  return (
    <div>
      <header style={{ background: "#333", color: "#fff", padding: "1px", textAlign: "center" }}>
        <h1>HOME4U</h1>
        <div style={{position: "absolute", top: "0px", left: "2px"}}>
          <p>{userState}</p>
          {userState ? <button onClick={logout}>Logout</button> : ""}
        </div>
      </header>
      <main>
        <Outlet /> {/* This renders the current route component */}
      </main>
    </div>
  )
};

export default Head;
 